import React, { FC } from "react";
import { withProcedureWraper } from "..";

export const ProcedureSafePage: FC = withProcedureWraper(() => {
  return <div className="ProcedureSafePage"></div>;
});
